import { useEffect, useRef, useState } from 'react'

import { getAIFinanceAccess, markAIFinancePreviewSeen } from '../../../../api'
import { EMPTY_FUNCTION } from '../../../../constants/common'
import { GretaAIChatFinanceAccess } from '../../GretaAIChat.constants'

import { GRETA_AI_CHAT_FINANCE_ACCESS_DEFAULT } from './useGretaAIChatFinanceAccess.constants'
import { getGretaAIChatNextFinanceAccess } from './useGretaAIChatFinanceAccess.utils'

export function useGretaAIChatFinanceAccess({ isPanelShown }) {
  const [financeAccess, setFinanceAccess] = useState(
    GRETA_AI_CHAT_FINANCE_ACCESS_DEFAULT
  )

  const latestRequestIdRef = useRef(0)

  // Read at the request start: a revoke and the re-read it starts share one render.
  const revocationRef = useRef(financeAccess.revocation)

  function applyFinanceAccess(request) {
    const requestId = ++latestRequestIdRef.current
    const revocation = revocationRef.current

    request
      .then(response => {
        if (requestId === latestRequestIdRef.current) {
          setFinanceAccess(current =>
            getGretaAIChatNextFinanceAccess({ current, response, revocation })
          )
        }
      })
      .catch(EMPTY_FUNCTION)
  }

  // Access can change in the admin while the page stays open.
  useEffect(() => {
    applyFinanceAccess(getAIFinanceAccess())
  }, [isPanelShown])

  function markFinanceUsed() {
    setFinanceAccess(current =>
      current.isUsed ? current : { ...current, isUsed: true }
    )
  }

  function markPreviewSeen() {
    if (!financeAccess.isPreviewSeen) {
      setFinanceAccess(current => ({ ...current, isPreviewSeen: true }))
      applyFinanceAccess(markAIFinancePreviewSeen())
    }
  }

  function revokeFinanceAccess() {
    const revocation = ++revocationRef.current

    setFinanceAccess(current => ({
      ...current,
      access: GretaAIChatFinanceAccess.NoAccess,
      isRevoked: true,
      isStale: false,
      revocation,
    }))
    applyFinanceAccess(getAIFinanceAccess())
  }

  return {
    financeAccess,
    markFinanceUsed,
    markPreviewSeen,
    revokeFinanceAccess,
  }
}
